<template>
  <div id="app">
    <promo-bar v-if="!exclude" />
    <router-view />
  </div>
</template>

<script>
import PromoBar from '@/components/promo-bar'
export default {
  name: 'App',
  components: {
    PromoBar
  },
  computed: {
    exclude: function () {
      // Hide the promobar until next event
      let arr = ['AppMonFx2', 'SparkSpecs', 'Spark', 'SparkMini', 'SparkLive', 'HelpCenter', 'HelpCenterDetail', 'riff_interface']
      return arr.includes(this.$route.name)
    }
  },
  watch: {
    '$route' (to, from) {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style>

body {
  margin: initial;
  overflow-x: hidden;
}

body.modal-open {
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue